import {
  Button,
  ButtonSize,
  ButtonWidth,
  IconSort,
  IconX,
} from '@leland-dev/leland-ui-library';
import React, { useState } from 'react';

import RadioInput from '../inputs/RadioInput';

interface MobileSortingFilterProps {
  options: Array<{ value: string; label: string; onSelect: () => void }>;
  selectedOption: string;
  className?: string;
}

const MobileSortingFilter: React.FC<MobileSortingFilterProps> = ({
  options,
  selectedOption,
  className,
}) => {
  const [showMobileSortingFilter, setShowMobileSortingFilter] = useState(false);

  const closeMobileSortingFilter = () => {
    setShowMobileSortingFilter(false);
  };

  return (
    <div className={`w-full ${className}`}>
      <Button
        label="Sort"
        LeftIcon={IconSort}
        size={ButtonSize.LARGE}
        width={ButtonWidth.FULL}
        onClick={() => setShowMobileSortingFilter(true)}
      />
      {showMobileSortingFilter ? (
        <div className="fixed inset-0 z-50 overflow-y-scroll bg-white lg:hidden">
          <div
            className={`fixed top-0 z-10 grid h-20 w-full auto-cols-fr grid-cols-3 gap-4 border-b border-leland-gray-stroke bg-white p-4 lg:relative lg:flex lg:min-h-fit lg:flex-row-reverse lg:items-center lg:justify-between lg:border-none lg:bg-transparent lg:px-8 lg:py-0`}
          >
            <h3 className="col-start-2 flex items-center justify-center text-lg font-medium text-leland-gray-dark">
              Sort Results
            </h3>
            <button
              className="col-start-3 ml-2 flex items-center justify-end"
              onClick={closeMobileSortingFilter}
              id="mobile_sorting_filter--close"
            >
              <IconX className="size-4 text-leland-gray-dark" />
            </button>
          </div>
          <div className="mt-20 py-6 lg:mt-0">
            {options.map((option) => (
              <div key={option.value} className="px-4 pb-6">
                <RadioInput
                  className="text-leland-primary"
                  labelClassName="font-medium"
                  name="sorting-filter"
                  option={option}
                  checked={option.value === selectedOption}
                  onChange={option.onSelect}
                />
                <hr className="mt-6" />
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default MobileSortingFilter;
